import { ResponsiveImage } from '~/graphql/fragments'
import { graphql } from '~/lib/datocms/graphql'

export const queryGames = graphql(
  /* GraphQL */ `
    query Games($first: IntType = 100, $skip: IntType, $inCategory: [ItemId]) {
      _allGamesMeta(filter: { category: { in: $inCategory } }) {
        count
      }
      allGames(
        first: $first
        skip: $skip
        filter: { category: { in: $inCategory } }
        orderBy: _firstPublishedAt_DESC
      ) {
        __typename
        _modelApiKey
        id
        category {
          __typename
          _modelApiKey
          id
          name
          slug
        }
        media {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 480 }
          ) {
            ...ResponsiveImage
          }
        }
        title
        url
        visits
        playing
      }
    }
  `,
  [ResponsiveImage]
)
